import React, { useEffect, useState } from 'react'
import {
  DashBoardFooter,
  BoxLabelFooter,
  TitleFooter,
  DescriptionFooter,
  BoxTableFooter,
} from '../../DashboardPlantasStyled';
import Tables from "../../../../../../components/Tables/Tables";
import { getIntervenciones } from '../../../../../../api/Inicio';
import { formatearFecha } from '../../../../../../components/Utils/Utils.ts';
import { Info } from '@mui/icons-material';
import { Tooltip, Box, Typography } from "@mui/material";

const DashboardFooter = () => {
  const [rows, setRows] = useState("");

  const columns = [
    { id: "fecha", label: "Fecha" },
    { id: "tipo", label: "Tipo Intervención" },
    { id: "nombre", label: "Intervención" },
    { id: "equipo", label: "Equipo" },
    { id: "planta", label: "Planta" }
  ]

  const handleClickButonTable = (value, valueRow) => {
    console.log(value, valueRow);
  }

  useEffect(() => {
    const fetchIntervenciones = async () => {
      try {
        const res = await getIntervenciones();
        setRows(
          res.data.map((res) => {
            const fechaFormat = res.fecha_inte;
            const fecha = formatearFecha(fechaFormat);
            return {
              fecha: fecha,
              tipo: res.tipo.description,
              nombre: res.observacion_inte ? (
                // <Tooltip title={res.desc_inte || ''}  >
                //   <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                //     <InfoIcon fontSize="small" sx={{ color: "#163C5B" }} /> {res.desc_inte?.slice(0, 10) + '...'}
                //   </Box>
                // </Tooltip>
                <Tooltip
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "#163C5B",
                        color: "#ffffff",
                        border: `3px solid #66BBD3`,
                        borderRadius: 3,
                        boxShadow: 3,
                        p: 1.5,
                        maxWidth: 250,
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#fefefe",
                      },
                    },
                  }}
                  title={
                    <Box p={1}>
                      <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                        Observaciones de la intervención
                      </Typography>
                      <Typography variant="body2" sx={{ maxWidth: 220 }}>
                        {res.observacion_inte ?? ""}
                      </Typography>
                    </Box>
                  }
                  arrow
                  placement="left"
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}>
                    <Info fontSize="small" sx={{ color: "#163C5B" }} />
                    {res.desc_inte}
                  </Box>
                </Tooltip>
              ) : res.desc_inte,
              equipo: res.equipo.desc_equi,
              planta: res.equipo.planta.description
            };
          })
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchIntervenciones();
  }, []);

  return (
    <DashBoardFooter>
      <BoxLabelFooter>
        <TitleFooter>Intervenciones</TitleFooter>
        <DescriptionFooter>Aquí podrá consultar las últimas 3 intervenciones registradas.
          Para crear nuevas intervenciones o realizar consultas, presione  la opción <span style={{ fontWeight: "bold" }}>“Intervenciones”</span>  que se encuentra en la cabecera
        </DescriptionFooter>
      </BoxLabelFooter>
      <BoxTableFooter>
        <Tables
          typeTable={"prop"}
          columns={columns}
          rows={rows}
          cRows={6}
          pagination={false}
          onClickButtonTable={(value, valuesRow) => { handleClickButonTable(value, valuesRow) }}
          onClickSwitch={false}
        />
      </BoxTableFooter>
    </DashBoardFooter>
  )
}

export default DashboardFooter